var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "hamburger_svg__a",
    width: 26.667,
    height: 3.2,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hamburger_svg__b",
    width: 26.667,
    height: 3.2,
    y: 6.4,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hamburger_svg__c",
    width: 26.667,
    height: 3.2,
    y: 12.8,
    rx: 1.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#hamburger_svg__a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.667,
    height: 2.2,
    x: 0.5,
    y: 0.5,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("use", {
    href: "#hamburger_svg__b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.667,
    height: 2.2,
    x: 0.5,
    y: 6.9,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("use", {
    href: "#hamburger_svg__c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.667,
    height: 2.2,
    x: 0.5,
    y: 13.3,
    rx: 1.1
  }))));
};
export default SvgHamburger;